import { Center, Checkbox } from '@mantine/core'
import { ShipmentType } from 'types/orders'
import { MantineTableCellProps, useEdit } from './useEdit'

export default function EditCheckboxInput(
  props: MantineTableCellProps<ShipmentType> & { error: string | undefined; onFocus: () => void }
) {
  const { value, handleOnChange, handleBlur } = useEdit(props)
  return (
    <Center>
      <Checkbox
        checked={value as boolean}
        onBlur={handleBlur}
        onChange={(e) => handleOnChange(e.currentTarget.checked)}
        error={props.error}
        onFocus={props.onFocus}
      />
    </Center>
  )
}
